"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatNumber = void 0;
const formatNumber = (value, { fixedDigits = 0, removeRightZero = false, } = {}) => {
    if (typeof value !== 'string' && typeof value !== 'number') {
        return '0';
    }
    const result = Number.isNaN(+value) ? '0' : Number(value).toFixed(fixedDigits);
    return removeRightZero ? String(parseFloat(result)) : result;
};
exports.formatNumber = formatNumber;
//# sourceMappingURL=formatNumber.js.map